module.exports = __webpack_public_path__ + "img/demi-cercle-yellow@2x.a8d7d8a8.png";